// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"267":"437a1572","431":"542f66e4","453":"5969648e","486":"d40d624e","937":"d6f37d17"}[chunkId] + ".chunk.js";
};